import { getFrontendURL } from 'src/utils/url';

export const QuotePlaceholderMap = (props: any) => {
  const {cls, mapNum = 1, height = 1024} = props;

  const times = Array(+mapNum).fill(1);

  return (
      <>
        {times.map((t, idx) => (
            <div key={idx} className={cls}>
              {idx > 0 && (
                  <div
                      className="placeholder-box"
                      style={{width: 400, height: 30}}
                  ></div>
              )}
              <div
                  style={{
                    width: "100%",
                    height: +height,
                    background: "#f7f7f7",
                    backgroundImage: `url('${getFrontendURL()}/images/placeholders/floor_placeholder.png')`,
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    marginBottom: 15,
                    filter: "blur(15px)",
                    opacity: 0.3,
                  }}
              ></div>
            </div>
        ))};
      </>
  )
};
